import React from "react";
import ToolbarWithHeading from "./ToolbarWithHeading";

const CascadeToolbar = () => {
  return <ToolbarWithHeading>Cascade Strategy</ToolbarWithHeading>;
};

export default CascadeToolbar;
